import { Injectable } from '@angular/core';
import { environment } from "../../../environments/environment";

@Injectable({
    providedIn: 'root'
})
export class GlassboxService {

    constructor() { }

    loadGlassboxScript(): void {
        const existingScript = document.getElementById('_cls_detector');
        if (!existingScript) {
            const script = document.createElement('script');
            script.type = 'text/javascript';
            script.id = '_cls_detector';
            script.src = environment.GlassBoxDetectorPath;
            script.async = true;
            script.setAttribute('data-clsconfig', environment.GlassBoxUri);
            document.body.appendChild(script);
        } else {
            if ((window as any)._detector) {
                (window as any)._detector.startRecording();
            }
        }
    }

    removeGlassboxScript(): void {
        const existingScript = document.getElementById('_cls_detector');
        if (existingScript) {
            if ((window as any)._detector) {
                (window as any)._detector.stopRecording();
            }
            existingScript.remove();
        }
    }

}